import React from 'react';
import _ from 'lodash';
import styles from './css/ServiceInfo.styl';
import {
  formatAddress,
  formatPhrase,
} from '../../../../../appModules/utilities/formatHelpers';
import {getMapUrl} from '../../../../shared/utilities/urlHelpers';
import moment from 'moment';

/**
 * The MainServices item on the person page
 * @param   {Object}  props - passed down props
 * @return  {JSX}     Returns a church
 */
const ServiceInfo = props => {
  const {services} = props.serviceGroup;

  return _.isEmpty(services) ? null : (
    <aside className={styles.ServiceInfo}>
      <h2 className={styles.header}>Service Information</h2>
      <div className={styles.itemGroup}>
        {services.map((originalService, index) => {
          const service = _.pick(originalService, [
            'city',
            'address',
            'postalCode',
            'state',
            'isPrivate',
            'isTBD',
            'serviceType',
            'location',
            'startTime',
            'dateUTC',
            'dateTimeDescription',
          ]);
          const isDateFallback = _.isEmpty(service.startTime);
          const serviceDate = service[isDateFallback ? 'dateUTC' : 'startTime'];
          const date = moment.utc(serviceDate);
          const time = date.format('h:mm A');
          const month = date.format('MMM').toUpperCase();
          const day = date.format('DD');
          const year = date.format('YYYY');

          service.city = formatPhrase(service.city);
          const itemAddress = formatAddress(service);
          const hideAddress =
            _.get(service, 'isPrivate', false) ||
            _.get(service, 'isTBD', false);

          return (
            <div className={styles.item} key={index}>
              {date.isValid() && year > 1900 ? (
                <div className={styles.ServiceLeft}>
                  <div className={styles.calendar}>
                    <div className={styles.top}>
                      <p className={styles.year}>{year}</p>
                    </div>
                    <div className={styles.bottom}>
                      <div className={styles.date}>
                        <p className={styles.month}>{month}</p>
                        <p className={styles.day}>{day}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              <div className={styles.ServiceRight}>
                {date.isValid() && !isDateFallback ? (
                  <p className={styles.time}>{time}</p>
                ) : null}
                {service.serviceType ? (
                  <p className={styles.type}>{service.serviceType}</p>
                ) : null}
                {service.location ? (
                  <p className={styles.location}>
                    {formatPhrase(service.location)}
                  </p>
                ) : null}
                {hideAddress ? null : (
                  <a
                    className={styles.address}
                    href={getMapUrl(itemAddress)}
                    target="_blank"
                  >
                    {itemAddress}
                  </a>
                )}
                {(!date.isValid() || isDateFallback) &&
                service.dateTimeDescription ? (
                  <p className={styles.description}>
                    {formatPhrase(service.dateTimeDescription)}
                  </p>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </aside>
  );
};

ServiceInfo.propTypes = {
  serviceGroup: React.PropTypes.object,
};

export default ServiceInfo;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/ServiceInfo/ServiceInfo.js